import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { Provider } from 'react-redux';
import { ChakraProvider } from '@chakra-ui/react';
import { GoogleOAuthProvider } from '@react-oauth/google';
import setupStore from '../store/store';
import AppRouter from './routes/AppRouter';
import AppFallback from '../common/components/AppFallback/AppFallback';
import { chakraTheme } from './theme/chakraTheme';
import '../i18n/i18n.module';
import './App.scss';

const googleClientId = process.env.REACT_APP_GOOGLE_CLIENT_ID || '';
const store = setupStore();
const toastPortalRef = {
  current:
    typeof document !== 'undefined' ? document.getElementById('toast-root') : null,
};

const App: React.FC = () => {
  if (!toastPortalRef.current && typeof document !== 'undefined') {
    toastPortalRef.current = document.getElementById('toast-root');
  }

  const tree = (
    <React.StrictMode>
      <Provider store={store}>
        <ChakraProvider
          theme={chakraTheme}
          toastOptions={{
            portalProps: { containerRef: toastPortalRef },
            defaultOptions: {
              position: 'bottom',
              duration: 15000,
              isClosable: true,
            },
          }}
        >
          <Router>
            <React.Suspense fallback={<AppFallback />}>
              <AppRouter />
            </React.Suspense>
          </Router>
        </ChakraProvider>
      </Provider>
    </React.StrictMode>
  );

  if (!googleClientId) {
    return tree;
  }

  return (
    <GoogleOAuthProvider clientId={googleClientId}>{tree}</GoogleOAuthProvider>
  );
};

export default App;
